// src/app/core/config/permisos-paginas.ts

import {TREASURY_PERMISSION_PAGES} from './treasury-permissions';
export const VIEW_TRACKING_DIAGNOSTICS =
  'productos/ingreso-rq/tracking-diagnostics';

export const PAGINAS_DISPONIBLES = [
  {
    categoria: 'USERS',
    paginas: [{ ruta: 'view-phone-users', nombre: 'Ver Usuarios Top Bar' }],
  },
  {
    categoria: 'Productos',
    paginas: [
      {
        ruta: VIEW_TRACKING_DIAGNOSTICS,
        nombre: 'Ver diagnóstico técnico del historial RQ',
      },
      { ruta: 'productos', nombre: 'Productos' },
      { ruta: 'productos/catalogo/ver', nombre: 'Ver catálogo de Productos' },
      {
        ruta: 'productos/catalogo/editar',
        nombre: 'Editar catálogo de productos ',
      },
      {
        ruta: 'catalogo-productos/requerimientos-express',
        nombre: 'Generar Requerimientos Express',
      },
      {
        ruta: 'ver-proveedores-compras',
        nombre: 'Ver Proveedores de Compras',
      },

      {
        ruta: 'productos/transferencias/entregas-epp/ver',
        nombre: 'Consultar entregas EPP por colaborador',
      },
      {
        ruta: 'productos/transferencias/entregas-epp/editar',
        nombre: 'Gestionar entregas, devoluciones y evidencias EPP',
      },
      {
              ruta: 'productos/transferencias/solicitud',
        nombre: 'Transferencias Productos',
      },
      {
        ruta: 'productos/transferencias/asignar-crear-bodega-proyectos',
        nombre: 'Asignar/Crear Bodega-Proyectos',
      },
      {
        ruta: 'productos/transferencias/editar',
        nombre: 'Acceso a Carrito completo',
      },
      {
        ruta: 'consumption_all_types_products',
        nombre: 'Consumo completo de todos los productos',
      },
      {
        ruta: 'productos/transferencias/auditorias-productos-bodega',
        nombre: 'Auditorias Productos-Bodega',
      },
      //Ajustes de inventario
      {
        ruta: 'productos/transferencias/ajuste_imperium',
        nombre: 'Ajuste Imperium',
      },
      { ruta: 'productos/inventario/visor', nombre: 'Ver/Inv. de Productos' },
      { ruta: 'productos/inventario/editar', nombre: 'Edit/Inv. de Productos' },

      //Permisos para quienes puedan modificar inventario la cantidad inicial o
      // la subida de compras por comprobante o regularizacion
      {
        ruta: '1401',
        nombre: 'Puede Ajustar Cantidad Inicial',
      },
      {
        ruta: 'unlimited_initial_adjustment_permission',
        nombre: 'Puede Ajustar Cantidad Inicial Ilimitadamente',
      },
      {
        ruta: '1402',
        nombre: 'Puede Ajustar Cant. disponible por Compras',
      },
      {
        ruta: '1403',
        nombre: 'Puede Ajustar Cant. disponible por Regularización',
      },
      {
        //1404ingreso por compras
        ruta: '1404',
        nombre: 'Puede Ingresar Productos por archivo Excel',
      },
      {
        ruta: '1405',
        nombre: 'Puede Cambiar la cantidad asignada en el Visor de Inventario',
      },
      //Control de ingresos
      {
        ruta: 'productos/inventario/control-ingresos',
        nombre: 'Control Ingresos',
      },
      //ingreso por compras
      {
        ruta: 'productos/inventario/ingreso-por-compras',
        nombre: 'Ingreso por Compras',
      },
      //productos/budget/ver

      {
        ruta: 'productos/ingreso-rq/tracking',
        nombre: 'Mis Requerimientos',
      },

      {
        ruta: 'productos/delivery/bodega',
        nombre: 'Envíos a Proyectos',
      },

      {
        ruta: 'productos/delivery/project',
        nombre: 'Recepción de Proyectos',
      },

      //rq.supervisor.ver_todos
    ],
  },

  {
    categoria: 'Requerimientos',
    paginas: [
      { ruta: 'productos/compras/productos', nombre: 'Modulo de Compras' },
      { ruta: 'productos/ingreso-rq', nombre: 'Requerimientos module' },

      {
        ruta: 'productos/ingreso-rq/editarRQ',
        nombre: 'Editar Requerimientos',
      },

      {
        ruta: 'productos/ingreso-rq/editarCodigosRQ',
        nombre: 'Editar Códigos de Requerimientos',
      },

      {
        ruta: 'productos/ingreso-rq/charts',
        nombre: 'Estadisticas de Requerimientos',
      },

      {
        ruta: 'productos/ingreso-rq/envios',
        nombre: 'Envios de Requerimientos',
      },

      {
        ruta: 'productos/ingreso-rq/tracking',
        nombre: 'Seguimiento de Requerimientos',
      },

      {
        ruta: 'rq.supervisor.ver_todos',
        nombre: 'Aprobador de supervisores: Todo',
      },
      {
        ruta: 'productos/aprobaciones-bodega',
        nombre: 'Aprobaciones de Bodega',
      },
      {
        ruta: 'productos/aprobaciones-presupuesto',
        nombre: 'Aprobaciones de Presupuesto',
      },

      //productos/ingreso-rq/ordenes
      {
        ruta: 'productos/ingreso-rq/ordenes',
        nombre: 'Filtrar Ordenes de Requerimientos',
      },

      {
        ruta: 'productos/rq-reserva/revertir-cancelar',
        nombre: 'Revertir Cancelacion de Reservas',
      },
      {
        ruta: 'productos/ingreso-rq/reports',
        nombre: 'Reportes de Envios',
      },
      {
        ruta: 'productos/ingreso-rq/metrics',
        nombre: 'Metricas de Envios',
      },
      {
        ruta: 'productos/ingreso-rq/pmo-price',
        nombre: 'Ver Precios en Compras Realizadas (Seguimiento)',
      },
      {
        ruta: 'productos/ingreso-rq/cambio-limites',
        nombre: 'Cambio de Límites',
      },
    ],
  },
  {
    categoria: 'Compras',
    paginas: [
      { ruta: 'productos/budget/ver', nombre: 'Compras [Productos]' },
      {
        ruta: 'servicios/budget/ver',
        nombre: 'Compras [Servicios]',
      },
      {
        ruta: 'productos/compras/cancelar',
        nombre: 'Cancelar compras pendientes',
      },
      {
        ruta: 'productos/compras/standBy',
        nombre: 'Permisos para standBy',
      },
      {
        ruta: 'productos/compras/cotizaciones',
        nombre: 'Permisos para Cotizaciones',
      },
    ],
  },
  {
    categoria: 'Mantenimientos',
    paginas: [
      { ruta: 'mantenimientos', nombre: 'Mantenimientos' },
      {
        ruta: 'mantenimientos/mantenimientos-km-hr/mantenimientos-km-hr-formulario',
        nombre: 'Mantenimientos Km/HR',
      },
      {
        ruta: 'mantenimientos/mantenimientos-km-hr/editar',
        nombre: 'Editar Mantenimientos Km/HR',
      },
      {
        ruta: 'mantenimientos/mantenimientos-km-hr/registrarUso',
        nombre: 'Registrar uso Km/HR',
      },
    ],
  },
  //project-control/matriz-iperc/kyara-ai
  {
    categoria: 'Control de Proyectos',
    paginas: [
      {
        ruta: 'project-control/matriz-iperc/kyara-ai',
        nombre: 'Matriz IPERC - Kyara AI',
      },
      {
        ruta: 'project-control/matriz-iperc/kyara-ai/admin',
        nombre: 'Administrar Kyara AI',
      },
      {
        ruta: 'project-control/projects',
        nombre: 'Proyectos',
      },
    ],
  },

  {
    categoria: 'Fatiga',
    paginas: [
      { ruta: 'fatigue/assessment', nombre: 'Evaluación automática de Fatiga' },
      { ruta: 'fatigue/admin', nombre: 'Administración de Fatiga' },
      { ruta: 'fatigue/configuration', nombre: 'Configuración de Fatiga' },
      { ruta: 'fatigue/editValue', nombre: 'Editar Valor de Fatiga' },
    ],
  },

  ///kyara-ai
  {
    categoria: 'Kyara AI',
    paginas: [
      {
        ruta: 'ai/kyara',
        nombre: 'Kyara AI',
      },
    ],
  },
  {
    categoria: 'Servicios Misceláneos',
    paginas: [
      { ruta: 'servicios-miscelaneos/clientes', nombre: 'Gestión de Clientes' },
      {
        ruta: 'servicios-miscelaneos/solicitudes-contratacion',
        nombre: 'Solicitudes de Contratación',
      },
      { ruta: 'servicios-miscelaneos/kpis', nombre: 'KPIS' },
    ],
  },
  {
    categoria: 'Tareas ZIVO',
    paginas: [{ ruta: 'tasklist/mis-tareas', nombre: 'Mis Tareas' }],
  },
  {
    categoria: 'SSA',
    paginas: [
      { ruta: 'ssa', nombre: 'SSA' },
      { ruta: 'ssa/capacitaciones', nombre: 'Capacitaciones' },
      { ruta: 'ssa/materiales', nombre: 'Materiales' },
    ],
  },
  {
    categoria: 'Pagos',
    paginas: [
      ...TREASURY_PERMISSION_PAGES,
      {ruta:'pagos/seguimiento-financiero/ver',nombre:'Consultar seguimiento financiero de pagos'},
      {ruta:'pagos/seguimiento-financiero/todas-las-areas',nombre:'Seguimiento financiero: alcance global de áreas de la propia empresa'},
      {
        ruta: 'pagos/configuraciones',
        nombre: 'Configuraciones',
      },
      {
        ruta: 'pagos/dashboard',
        nombre: 'Dashboard Admin',
      },
      {
        ruta: 'pagos/proveedores',
        nombre: 'Lista de Proveedores',
      },
      {
        ruta: 'pagos/pagos-proveedores',
        nombre: 'Pagos a Proveedores',
      },
      {
        ruta: 'pagos/pagos-proveedores/ocultar-pendientes',
        nombre: 'Ocultar SP pendientes con historial (solo frontend)',
      },
      {
        ruta: 'pagos/aprobaciones-pagos',
        nombre: 'Aprobaciones de Pagos',
      },
      {
        ruta: 'pagos/aprobaciones-pagos/ver-totales',
        nombre: 'Totales de Pagos',
      },
      {
        ruta: 'pagos/aprobaciones-pagos/revertir-tesoreria',
        nombre: 'Revertir Completos -> Pendientes Tesoreria',
      },
      {
        ruta: 'pagos/pagos-proveedores-actualizar-en-todos',
        nombre: 'Actualizar En Todos',
      },
      //9999
      {
        ruta: '9999',
        nombre: 'Eliminar Proveedores / Bancos / Cuentas',
      },
    ],
  },
  {
    categoria: 'Colaboradores',
    paginas: [
      { ruta: 'colaboradores', nombre: 'Colaboradores' },
      { ruta: 'colaboradores/calificaciones', nombre: 'Calificaciones' },
    ],
  },
  {
    categoria: 'Recursos Humanos',
    paginas: [
      { ruta: 'recursos-humanos', nombre: 'Recursos Humanos' },

      {
        ruta: 'recursos-humanos/personal',
        nombre: '**Modulo Personal**',
      },
      {
        ruta: 'recursos-humanos/personal/birthdays',
        nombre: '- Cumpleaños',
      },
      {
        ruta: 'recursos-humanos/personal/departamentos',
        nombre: '- Departamentos',
      },
      {
        ruta: 'recursos-humanos/personal/documentos',
        nombre: '- *Gestión documental*',
      },
      {
        ruta: 'recursos-humanos/personal/documentos/categorias',
        nombre: '- Gestión documental (Categorías)',
      },
      {
        ruta: 'recursos-humanos/personal/documentos/empleados',
        nombre: '- Gestión documental (Empleados)',
      },
      {
        ruta: 'recursos-humanos/personal/documentos/prospectos',
        nombre: '- Gestión documental (Prospectos)',
      },
      {
        ruta: 'recursos-humanos/personal/empleados',
        nombre: '- Empleados',
      },
      {
        ruta: 'recursos-humanos/personal/empleados/consulta',
        nombre: '- Consulta de empleados (sin sueldo)',
      },
      {
        ruta: 'recursos-humanos/personal/biometrico',
        nombre: '- Marcación del biométrico',
      },
      {
        ruta: 'recursos-humanos/personal/asistencias-biometricas',
        nombre: '- Asistencias biométricas ZKBio',
      },
      {
        ruta: 'recursos-humanos/personal/correos-empresariales',
        nombre: '- Correos empresariales Microsoft 365',
      },
      {
        ruta: 'recursos-humanos/personal/vacunas',
        nombre: '- Vacunas',
      },

      {
        ruta: 'recursos-humanos/contratacion',
        nombre: '**Modulo Contratación**',
      },
      {
        ruta: 'recursos-humanos/contratacion/canales-reclutamiento',
        nombre: '- Canales de Reclutamiento',
      },
      {
        ruta: 'recursos-humanos/contratacion/competencias',
        nombre: '- Competencias del prospecto',
      },
      {
        ruta: 'recursos-humanos/contratacion/contratos',
        nombre: '- Contratos',
      },
      {
        ruta: 'recursos-humanos/contratacion/contratos/tipos',
        nombre: '- Tipos de Contrato',
      },
      {
        ruta: 'recursos-humanos/contratacion/obligaciones-trabajador',
        nombre: '- Obligaciones del Trabajador',
      },
      {
        ruta: 'recursos-humanos/contratacion/prospectos',
        nombre: '- Prospectos',
      },
      {
        ruta: 'recursos-humanos/contratacion/proceso-simple',
        nombre: '- Proceso simple de contratación',
      },
      {
        ruta: 'recursos-humanos/contratacion/proceso-simple/gestion',
        nombre: '- Gestión masiva de contratación',
      },
      {
        ruta: 'recursos-humanos/contratacion/proceso-simple/documentos',
        nombre: '- Documentación múltiple y trazabilidad',
      },
      {
        ruta: 'recursos-humanos/contratacion/proceso-simple/contrataciones',
        nombre: '- Bandeja integral de contrataciones',
      },
      {
        ruta: 'recursos-humanos/contratacion/requerimientos',
        nombre: '- Requerimientos',
      },
      {
        ruta: 'recursos-humanos/contratacion/recontrataciones',
        nombre: '- Recontrataciones',
      },
      {
        ruta: 'recursos-humanos/contratacion/dashboard',
        nombre: '- Dashboard Gerencial',
      },
      {
        ruta: 'recursos-humanos/contratacion/kpis',
        nombre: '- KPIs RRHH',
      },
      {
        ruta: 'recursos-humanos/contratacion/ingresos-nuevos',
        nombre: '- Nuevos ingresos',
      },

      {
        ruta: 'recursos-humanos/desvinculacion',
        nombre: '**Modulo Desvinculación**',
      },
      {
        ruta: 'recursos-humanos/desvinculacion/desvinculaciones',
        nombre: '- Desvinculaciones',
      },

      {
        ruta: 'recursos-humanos/cargos',
        nombre: '**Modulo Cargos**',
      },
      {
        ruta: 'recursos-humanos/cargos/niveles-experiencia',
        nombre: '- Niveles de experiencia',
      },
      {
        ruta: 'recursos-humanos/cargos/plantillas',
        nombre: '- *Plantillas*',
      },
      {
        ruta: 'recursos-humanos/cargos/plantillas/configuracion',
        nombre: '- Plantillas (Configuración)',
      },
      {
        ruta: 'recursos-humanos/cargos/plantillas/general-view',
        nombre: '- Plantillas (Vista General)',
      },
      {
        ruta: 'recursos-humanos/cargos/plantillas/versiones',
        nombre: '- Plantillas (Versiones)',
      },
      {
        ruta: 'recursos-humanos/cargos/roles',
        nombre: '- Cargos',
      },
      {
        ruta: 'recursos-humanos/cargos/sectoriales',
        nombre: '- Sectoriales',
      },
      {
        ruta: 'recursos-humanos/cargos/sectoriales-iess',
        nombre: '- Sectoriales IESS',
      },
      {
        ruta: 'recursos-humanos/prestamos',
        nombre: 'Préstamos',
      },
      {
        ruta: 'recursos-humanos/procesos',
        nombre: '**Modulo Procesos**',
      },
      {
        ruta: 'recursos-humanos/procesos/departamentos',
        nombre: '- Departamentos',
      },
      {
        ruta: 'recursos-humanos/procesos/departamentos/plantillas',
        nombre: '- *Plantillas*',
      },
      {
        ruta: 'recursos-humanos/procesos/departamentos/plantillas/configuracion',
        nombre: '- Plantillas (Configuración)',
      },
      {
        ruta: 'recursos-humanos/procesos/departamentos/plantillas/general-view',
        nombre: '- Plantillas (Vista General)',
      },
      {
        ruta: 'recursos-humanos/procesos/departamentos/plantillas/versiones',
        nombre: '- Plantillas (Versiones)',
      },
      {
        ruta: 'recursos-humanos/procesos/principales',
        nombre: '- Principales',
      },
      {
        ruta: 'recursos-humanos/procesos/secundarios',
        nombre: '- Secundarios',
      },

      {
        ruta: 'recursos-humanos/eventos',
        nombre: '**Modulo Eventos**',
      },
      {
        ruta: 'recursos-humanos/eventos/categorias',
        nombre: '- Categorías',
      },
      {
        ruta: 'recursos-humanos/eventos/events',
        nombre: '- Eventos',
      },
      {
        ruta: 'recursos-humanos/eventos/vacaciones',
        nombre: 'Vacaciones',
      },
      {
        ruta: 'recursos-humanos/eventos/eventos-empleado',
        nombre: '- Eventos de Empleado',
      },
      {
        ruta: 'recursos-humanos/eventos/eventos-empleado/solicitudes',
        nombre: '- Solicitud de Eventos',
      },
      {
        ruta: 'recursos-humanos/eventos/eventos-empleado/internos',
        nombre: '- Eventos Internos',
      },
      {
        ruta: 'recursos-humanos/eventos/eventos-empleado/externos',
        nombre: '- Eventos Externos',
      },
      {
        ruta: 'recursos-humanos/eventos/eventos-empleado/automatizaciones',
        nombre: '- Automatizaciones',
      },
      {
        ruta: 'recursos-humanos/eventos/dashboard',
        nombre: 'Dashboard'
      },
      {
        ruta: 'recursos-humanos/eventos/dashboard/solicitud-eventos',
        nombre: 'Dashboard Solicitud de Eventos'
      },
      {
        ruta: 'recursos-humanos/apt',
        nombre: 'Apto',
      },
      {
        ruta: 'recursos-humanos/attendance',
        nombre: 'Asistencia',
      },
      {
        ruta: 'recursos-humanos/attendance-categories-events',
        nombre: 'Categorías y Eventos de Asistencia',
      },
      {
        ruta: 'recursos-humanos/pay-comprobants',
        nombre: 'Comprobantes de Pago',
      },
      {
        ruta: 'recursos-humanos/shift-schedule',
        nombre: 'Entrada y Salida de Empleados',
      },
      {
        ruta: 'recursos-humanos/feriados',
        nombre: 'Feriados',
      },
      {
        ruta: 'recursos-humanos/projections',
        nombre: 'Proyecciones',
      },
      {
        ruta: 'recursos-humanos/payroll',
        nombre: 'Rol de Pagos',
      },
      {
        ruta: 'recursos-humanos/payroll-concepts',
        nombre: 'Conceptos de Nómina',
      },
      {
        ruta: 'recursos-humanos/roles-de-pagos',
        nombre: 'Roles de Pagos',
      },

      // { ruta: 'recursos-humanos/kpis', nombre: 'KPIS' }
    ],
  },

  {
    categoria: 'ITE',
    paginas: [
      { ruta: 'ite', nombre: 'Módulo ITE' },
      { ruta: 'ite/dashboard', nombre: '- Dashboard ITE' },
      {
        ruta: 'ite/almacenamiento-temporal',
        nombre: '- Almacenamiento temporal',
      },
      {
        ruta: 'ite/inventario',
        nombre: '- Inventario tecnológico',
      },
      {
        ruta: 'ite/entregas-recepciones',
        nombre: '- Entregas y recepciones',
      },
      {
        ruta: 'ite/ingresos-computadoras',
        nombre: '- Computadoras de nuevos ingresos',
      },
      {
        ruta: 'ite/correos-corporativos',
        nombre: '- Correos corporativos',
      },
      {
        ruta: 'ite/configuracion',
        nombre: '- Configuración ITE',
      },
    ],
  },
  {
    categoria: 'Repositorio',
    paginas: [
      { ruta: 'repositorio', nombre: 'Repositorio' },
      {
        ruta: 'repositorio/documentos-electritel',
        nombre: 'Documentos Electritel',
      },
      { ruta: 'repositorio/ver', nombre: 'Repositorio Ver' },
      { ruta: 'repositorio/editar', nombre: 'Repositorio Editor' },
    ],
  },
  {
    categoria: 'Configuraciones',
    paginas: [
      { ruta: 'configuraciones', nombre: 'Modulo Configuraciones' },
      { ruta: 'configuraciones/usuarios-lista', nombre: 'Gestionar Usuarios' },
      { ruta: 'configuraciones/permisos', nombre: 'Gestionar Permisos' },
      { ruta: 'configuraciones/access-control', nombre: 'Control de Acceso' },
      {
        ruta: 'configuraciones/politicas-consentimientos',
        nombre: 'Políticas de privacidad',
      },
      { ruta: 'configuraciones/nomina-eventos', nombre: 'Nómina de Eventos' },
      {
        ruta: 'configuraciones/approval-settings',
        nombre: 'Configuracion de Aprobaciones',
      },
      { ruta: 'configuraciones/settings', nombre: 'Configuraciones' },
      { ruta: 'configuraciones/tema', nombre: 'Tema de pantalla' },
    ],
  },
  {
    categoria: 'Formularios',
    paginas: [
      { ruta: 'formularios', nombre: 'Formularios' },

      {
        ruta: 'formularios/apto',
        nombre: '- Apto',
      },
      {
        ruta: 'formularios/solicitudes-contratacion',
        nombre: 'Cotización de Servicios',
      },
      {
        ruta: 'formularios/contratacion',
        nombre: 'Contratación',
      },
      {
        ruta: 'formularios/desvinculacion',
        nombre: 'Desvinculación',
      },
      {
        ruta: 'formularios/eventos-empleado',
        nombre: 'Eventos Empleado',
      },
      {
        ruta: 'formularios/solicitud-eventos',
        nombre: 'Solicitud de eventos'
      },
      {
        ruta: 'formularios/solicitud-eventos/configuracion',
        nombre: 'Solicitud de eventos · Configurar aprobadores',
      },
      {
        ruta: 'formularios/solicitud-eventos/ver-todos',
        nombre: 'Solicitud de eventos · Ver todas',
      },
      {
        ruta: 'formularios/entrada-salida-empleado',
        nombre: '- Entrada y Salida de Empleados',
      },
      {
        ruta: 'formularios/ite/entrega-recepcion',
        nombre: '- ITE · Entrega y recepción de equipos',
      },
    ],
  },
  {
    categoria: 'Tareas Equipo',
    paginas: [
      {
        ruta: 'tasks',
        nombre: 'Módulo Tareas Equipo',
      },
      {
        ruta: 'tasks/dashboard',
        nombre: 'Tareas Equipo - Dashboard',
      },
      {
        ruta: 'tasks/tasks',
        nombre: 'Tareas Equipo - Tablero de tareas',
      },
      {
        ruta: 'tasks/tasks/detail',
        nombre: 'Tareas Equipo - Detalle de tarea',
      },
      {
        ruta: 'tasks/projects',
        nombre: 'Tareas Equipo - Proyectos',
      },
      {
        ruta: 'tasks/teams',
        nombre: 'Tareas Equipo - Equipos',
      },
      {
        ruta: 'tasks/sites',
        nombre: 'Tareas Equipo - Sitios de trabajo',
      },
      {
        ruta: 'tasks/attachments',
        nombre: 'Tareas Equipo - Evidencias y adjuntos',
      },
      {
        ruta: 'tasks/time-entries',
        nombre: 'Tareas Equipo - Registro de tiempos',
      },
      {
        ruta: 'tasks/comments',
        nombre: 'Tareas Equipo - Comentarios',
      },
      {
        ruta: 'tasks/dependencies',
        nombre: 'Tareas Equipo - Dependencias',
      },
      {
        ruta: 'tasks/activity-logs',
        nombre: 'Tareas Equipo - Historial de actividad',
      },
    ],
  },
  {
    categoria: 'Mi equipo',
    paginas: [
      { ruta: 'teams', nombre: 'Mi equipo' },
      { ruta: 'teams/my-team', nombre: 'Equipo' },
      {
        ruta: 'teams/my-team/distribucion',
        nombre: 'Mi equipo - Mi distribución de equipo',
      },
      {
        ruta: 'teams/my-team/configuracion/responsables',
        nombre: 'Mi equipo - Configurar responsables SSA, supervisores y QA/QC',
      },
      {
        ruta: 'teams/my-team/distribucion/asignar-supervisores',
        nombre: 'Mi equipo - Designar supervisores a proyectos',
      },
      {
        ruta: 'teams/my-team/asistencia',
        nombre: 'Mi equipo - Asistencia',
      },
      {
        ruta: 'teams/my-team/biometrico',
        nombre: 'Mi equipo - Marcación biométrica',
      },
    ],
  },
  {
    categoria: 'Inicio',
    paginas: [{ ruta: 'home', nombre: 'Inicio' }],
  },
  {
    categoria: 'Tickets',
    paginas: [{ ruta: 'tickets/listado', nombre: 'Tickets' }],
  },
];
